export default "__VITE_ASSET__a99YPBnd__"